<template>
    <div class="" id="chat-msg">
    <!-- With Name and Arrow - LEFT -->
    <div class="msg" v-for="chat in history">
        <div class="bubble" :class="chat.me ? 'alt': ''">
            <div class="txt">
            <span v-if="!chat.me" class="name" :class="chat.me ? 'alt': ''">{{chat.name}}</span>
        <!--       <span class="timestamp">10:20 pm</span>       -->
            <span class="message">
                {{chat.msg}}
            </span> 
            
            </div>
            <div class="bubble-arrow" :class="chat.me ? 'alt': ''"></div>
            </div>
        </div>  

    </div>
</template>
<style scoped>


.container {
  width: 75%;
  margin: 0 auto;
}
#chat-msg{
  height: 310px;
  overflow-x: hidden;
}
.msg {
  width: 100%;
  height: auto;
  display: block;
  overflow: hidden;
}
.msg .bubble {
  float: left;
  max-width: 75%;
  width: auto;
  height: auto;
  display: block;
  background: #ebebeb;
  border-radius: 5px;
  position: relative;
  margin: 10px 0 3px 25px;
  box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.2);
}
.msg .bubble.alt {
  margin: 10px 25px 3px 0px;
  background: #e6bdcb;
  float: right;
}
.msg .bubble.follow {
  margin: 2px 0 3px 25px;
}
.msg .bubble.altfollow {
  margin: 2px 25px 3px 0px;
  background: #DCF8C6;
  float: right;
}
.msg .bubble .txt {
  padding: 8px 0 8px 0;
  width: 100%;
}
.msg .bubble .txt .name {
  font-weight: 600;
  font-size: 14px;
  display: inline-table;
  padding: 0 0 0 15px;
  margin: 0 0 4px 0;
  color: #3498db;
}
.msg .bubble .txt .name span {
  font-weight: normal;
  color: #b3b3b3;
  overflow: hidden;
}
.msg .bubble .txt .name.alt {
  color: #2ecc51;
}
.msg .bubble .txt .message {
  font-size: 14px;
  font-weight: 500;
  padding: 0 15px 0 15px;
  margin: auto;
  color: #2b2b2b;
  display: table;
}
.msg .bubble .txt .timestamp {
  font-size: 11px;
  margin: auto;
  padding: 0 15px 0 0;
  display: table;
  float: right;
  position: relative;
  text-transform: uppercase;
  color: #999;
}
.msg .bubble .bubble-arrow {
  position: absolute;
  float: left;
  left: -11px;
  top: 0px;
}
.msg .bubble .bubble-arrow.alt {
  bottom: 20px;
  left: auto;
  right: 4px;
  float: right;
}
.msg .bubble .bubble-arrow:after {
  content: "";
  position: absolute;
  border-top: 15px solid #ebebeb;
  border-left: 15px solid transparent;
  border-radius: 4px 0 0 0px;
  width: 0;
  height: 0;
}
.msg .bubble .bubble-arrow.alt:after {
  border-top: 15px solid #e6bdcb;
  transform: scaleX(-1);
}

@media only screen and (max-width: 450px) {
  .container {
    width: 100%;
  }

  .timestamp {
    display: none;
    color: red;
  }
}

</style>
<script>
    import { Event } from '@/helpers/events';

    export default {
        name: 'Chat',
        data: () => ({
          hist: [],
        }),
        props: ['history'],
        created: function() {
          this.hist = this.history;
          const self = this;
            // Event.$on('updateComment', comments => {
            //   console.log('9999999999', comments);
            //     self.hist = comments;
            //     const messages = document.querySelector('#Acompanhamento .modal-content');
            //     messages.scrollTop = messages.scrollHeight + 20;
                
            // });
            if(this.history.length > 3){
              const messages = document.querySelector('#chat-msg');
              messages.scrollBottom = messages.scrollHeight + 20; 
          document.querySelector('#chat-msg').scrollIntoView(false)
            }
            
        },
        updated() {if(this.history.length > 3){
           const messages = document.querySelector('#chat-msg');
              messages.scrollBottom = messages.scrollHeight + 20; 
                  document.querySelector('#chat-msg').scrollIntoView(false);

        }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/common/Chat.vue